//console.log('loaded: 01-main.js');

document.addEventListener("DOMContentLoaded", () => {

  // Call set brand header.
  setBrandHeader();

  // Call auto add product to cart.
  autoAddProduct();

  // check for promo code and set cookie
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }
  if(getCookie("discount_code") && !getCookie("_img_promo_displayed")) {
    document.cookie = "_img_promo_displayed=true";
    //console.log(getCookie("discount_code") + " | " + getCookie("_img_promo_displayed"));
    document.getElementById("promo-alert-code").innerHTML = getCookie("discount_code");
    document.getElementById("promo-alert").style.display = "inline-block";
    const interval = setInterval(function () {
        clearInterval(interval);
        document.getElementById("promo-alert").style.display = "none";
    }, 10000)
  }

});

/**
 * Retrieves URL parameters based on a given parameter name
 *
 * @param {*} name
 */
function urlGetQuery(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results === null) {
        return null;
    }
    return decodeURIComponent(results[1]) || null;
}

function autoAddProduct() {
    const variant = urlGetQuery('variant');
    const qty = urlGetQuery('qty');
    if (!qty || !variant) {
        return;
    }
    const isAutoAdd = urlGetQuery('autoadd');
    console.log('Auto Add:', variant, qty, isAutoAdd);
    const productAddToCart = $('form[action="/cart/add"]');
    if (productAddToCart.length === 0) {
        return;
    }

    $('#Quantity').val(qty);
    $('.selector-wrapper.product-selector, .product-quantity, .product-details .product-add-to-cart').hide();

    const params = productAddToCart.serializeArray().reduce(function (red, el) {
        red[el.name] = el.value;
        return red;
     }, {});

     params.properties = {
        _participant_id: urlGetQuery('participant_id') || 'guest',
    };

    if (isAutoAdd !== 'true') {
        return;
    }

    const camppass = urlGetQuery('camppass');

    $.post(
        '/cart/add.js',
        params,
        function () {
            if(camppass){
              window.location = '/cart?camppass=true';
              return;
            }
            window.location = '/cart';
        }
    );
}

function setBrandHeader() {
  var sport = false;
  var sportImage = false;
  var brand = false;
  var brandImage = false;
  var bannerText = false;
  var bannerImage = false;
  var baseUrl = "https://cdn.shopify.com/s/files/1/0066/1769/4275/files/";


  // Get base URL
  var url = window.location.href;

  // Break up URL
  var splitURL = url.toString().split("/");
  var args = decodeURIComponent(splitURL[5]).toString().split("+");

  // Parse brand from URL params
  for (let i = 0; i < args.length; i++) {
    keys = args[i].toString().split('|');
    if(keys[1] == 'sports'){
      sport = keys[0].replace("-", " ");
      sportImage = baseUrl + keys[0] + ".png";
    }
    if(keys[1] == 'brands'){
      brand = keys[0].replace("-", " ");
      brandImage = baseUrl + keys[0] + ".png";
    }
  }

  if(sport){
    bannerText = sport;
    bannerImage = sportImage;
  }
  else if (brand){
    bannerText = brand;
    bannerImage = brandImage;
  }

    // Check to see if Brand is found.
  if(bannerText){
      // Set brand title
    document.getElementById("collection-list-title").innerHTML = bannerText;
      // Check to see if brand image exists
    var xhttp = new XMLHttpRequest();
    xhttp.open("GET", brandImage, true);

    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
          document.getElementById("collection-header").style.backgroundImage = "url('" + bannerImage + "')";
        }
    };
    xhttp.send();
  }
}

function closePromoAlert() {
  document.getElementById("promo-alert").style.display = "none";
}

/*
  Shopify Subscription Connector Script
  ----------------------------------------------------------------------
  Purpose: To bridge the selection made in the subscription app's custom UI
  (the radio buttons) to the required hidden input field named "selling_plan"
  which is necessary for the Shopify cart to process the subscription.
*/

// Use a self-executing anonymous function to ensure $ is mapped to jQuery
(function($) {
  // Wait until the entire document (including the subscription block) is ready.
  $(document).ready(function() {
    
    // --- Selectors ---
    
    // 1. Find all radio buttons that represent the actual 'selling_plan' selection.
    //    These are the inputs with the data-selling-plan-id attribute.
    const $sellingPlanRadios = $('input[type="radio"][data-radio-type="selling_plan"]');
    
    // 2. Find the critical hidden input field that the cart reads.
    const $hiddenSellingPlanInput = $('input[name="selling_plan"].selected-selling-plan-id');

    // 3. Find the radio button for the 'One-time purchase' (if it exists).
    //    We assume 'One-time' is the radio button that selects the whole group, 
    //    and does not have a data-selling-plan-id attribute.
    const $oneTimeRadio = $('input[type="radio"][data-radio-type="one_time_purchase"]');
    
    
    // --- Initial State Setup ---
    
    // On load, ensure the hidden input is set based on which radio is initially checked.
    function updateHiddenInput() {
      console.log('--- updateHiddenInput() called ---'); // New log: Function start
      
      // Check for a checked selling plan radio
      const $checkedSellingPlan = $sellingPlanRadios.filter(':checked');
      console.log('Checked selling plan radios found (length):', $checkedSellingPlan.length); // New log: Radios found
      
      if ($checkedSellingPlan.length) {
        console.log('Path: Subscription plan selected.'); // New log: Subscription path
        // If a subscription plan is checked, use its ID.
        const selectedId = $checkedSellingPlan.attr('data-selling-plan-id');
        console.log('Extracted Selling Plan ID:', selectedId); // New log: Extracted ID
        $hiddenSellingPlanInput.val(selectedId);
      } else if ($oneTimeRadio.length && $oneTimeRadio.filter(':checked').length) {
        console.log('Path: One-Time Purchase selected.'); // New log: One-time path
        // If the 'one-time purchase' radio is checked, set value to empty string.
        $hiddenSellingPlanInput.val('');
      } else {
        console.log('Path: Fallback - no specific option checked.'); // New log: Fallback path
        // Fallback for cases where neither is checked (shouldn't happen in Shopify)
        $hiddenSellingPlanInput.val(''); 
      }
    }
    
    // Run once on document ready
    updateHiddenInput();


    // --- Event Listener ---

    // 4. Attach a 'change' listener to ALL radio buttons within the subscription block.
    //    We listen to the container because the IDs are dynamically generated.
    $('.subscriptions_app_embed_block').on('change', 'input[type="radio"]', function() {
      console.log('Radio button changed, triggering update...'); // New log: Change event
      // Re-run the update logic whenever any radio button in the block changes.
      updateHiddenInput();
    });

    // Final check for debugging: log the value when the input is updated
    $hiddenSellingPlanInput.on('change', function() {
      console.log('Hidden Selling Plan ID Updated to:', $(this).val());
    });
    
  });
})(jQuery);

// IMGA+ 1:1 Student Info Popup - bypass flag
var _imgaPlusPopupCompleted = false;

$(document).on('click', '#addToCart', function(e) {
  e.preventDefault();

  var $btn = $(this);
  var productType = $btn.data('producttype');

  // Intercept for IMGA+ 1:1 products to collect student info via popup
  if (productType === 'IMGA+ - 1:1' && !_imgaPlusPopupCompleted) {
    openStudentInfoPopup(function() {
      $btn.trigger('click');
    });
    return;
  }

  // Reset bypass flag
  _imgaPlusPopupCompleted = false;

  // Enforce required field validation
  var form = $btn.closest('form')[0];
  if (form && !form.checkValidity()) {
    form.reportValidity();
    return;
  }

  // Get variant ID (update selector if needed)
  let variantId = $('select[name="id"]').val();
  let sellingPlanId = $('input[name="selling_plan"].selected-selling-plan-id').val();
  let quantity = $('input[name="quantity"]').val() || 1;

  // Gather all line item property fields into a properties object
  let properties = {};
  document.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(function(input) {
    if (input.value.trim()) {
      properties[input.name.replace(/^properties\[(.*)\]$/, '$1')] = input.value.trim();
    }
  });

  // Build data for Shopify AJAX API
  let params = {
    quantity: quantity,
    id: variantId,
    properties: properties
  };

  console.log('Selling Plan ID:', sellingPlanId);

  if(sellingPlanId){
    params.selling_plan = sellingPlanId;
  }

  // Post to Shopify cart
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: params,
    dataType: 'json',
    success: function() {
      window.location.href = "/cart";
    },
    error: function(e) {
      console.log('There was an error adding to cart.', e)
      alert("There was an error adding to cart.");
    }
  });
});

/**
 * Opens the student athlete information popup for IMGA+ 1:1 products.
 * Collects Name (required), Email (required), Phone (optional).
 */
function openStudentInfoPopup(onSaveCallback) {
  var popupHtml = [
    '<style>',
    '  .student-info-popup { padding: 10px 0; position: relative; }',
    // ContentOverlay2 auto-injects its own close button (theme.js:2947 —
    // <button class="popup-close close icon-close-icon">), the legacy
    // "✕ close" text style (see .popup-close in theme.scss) used on other
    // camp popups. Hide it and use our own, matching the "Request
    // Consultation" lead-form's close control exactly (.lf-close /
    // .lf-close-glyph markup/SVG) instead — .close is ContentOverlay2\'s
    // own default close-button selector (btnClose: \'.close\'), so this
    // still closes the overlay with no extra JS wiring.
    '  .student-info-overlay .popup-close { display: none !important; }',
    '  .student-info-close { position: absolute; top: -10px; right: -10px; width: 24px; height: 24px; padding: 0; border: none; background: none; color: #080f17; cursor: pointer; }',
    '  .student-info-close svg { display: block; width: 100%; height: 100%; }',
    '  .student-info-popup h2 { margin: 0 0 24px; padding-right: 24px; font-family: "DM Sans", sans-serif; font-size: 24px; font-weight: 600; line-height: 1.18; text-align: left; text-transform: none; color: #080f17 !important; -webkit-text-fill-color: #080f17 !important; }',
    // Reference design has no visible field labels — just placeholder text
    // under one blue uppercase group eyebrow (e.g. "ATHLETE INFO"). Keep the
    // <label> for accessibility (still associates via for=), just hide it
    // visually (sr-only) instead of deleting it.
    '  .student-info-eyebrow { display: block; margin-bottom: 12px; font-family: "DM Sans", sans-serif; font-weight: 500; font-size: 13px; letter-spacing: 0.08em; text-transform: uppercase; color: #006feb !important; -webkit-text-fill-color: #006feb !important; text-align: left; }',
    '  .student-info-field { margin-bottom: 10px; }',
    '  .student-info-field label { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0; }',
    // theme.scss:10857 (input:not([type=submit]):not([type=checkbox])) sets
    // background/color/-webkit-text-fill-color with !important, and its two
    // :not() clauses give it HIGHER SPECIFICITY than a plain class selector
    // even among !important rules (specificity is still the tiebreaker
    // between two !important declarations) — .student-info-field alone
    // isn't enough to beat it. Stack the overlay + popup ancestor classes
    // too so this selector's specificity clears theirs, and match every
    // vendor-prefixed placeholder pseudo (that legacy rule targets those
    // directly rather than the standard ::placeholder).
    '  .student-info-overlay .student-info-popup .student-info-field input { width: 100%; padding: 12px 16px; border: 1px solid #d5dbe1; border-radius: 8px; font-family: "DM Sans", sans-serif; font-size: 16px; box-sizing: border-box; background: #fff !important; background-color: #fff !important; color: #080f17 !important; -webkit-text-fill-color: #080f17 !important; }',
    '  .student-info-overlay .student-info-popup .student-info-field input::placeholder,',
    '  .student-info-overlay .student-info-popup .student-info-field input:-moz-placeholder,',
    '  .student-info-overlay .student-info-popup .student-info-field input:-ms-input-placeholder,',
    '  .student-info-overlay .student-info-popup .student-info-field input::-moz-placeholder,',
    '  .student-info-overlay .student-info-popup .student-info-field input::-webkit-input-placeholder { color: #8f9fb0 !important; }',
    '  .student-info-field input:focus { border-color: #006feb; outline: none; box-shadow: 0 0 0 1px #006feb; }',
    '  .student-info-field.has-error input { border-color: #be143d; }',
    '  .student-info-field .field-error { display: block; color: #be143d; font-size: 12px; margin-top: 2px; min-height: 0; }',
    '  .student-info-field .field-error:empty { margin-top: 0; }',
    // <p> inherits the theme\'s body{color:#006feb} (see _personal-coach.scss\'s
    // note on the same issue) — needs !important to actually land as grey.
    '  .student-info-note { font-family: "DM Sans", sans-serif; font-size: 12px; color: #587089 !important; -webkit-text-fill-color: #587089 !important; line-height: 1.37; margin: 8px 0 20px; }',
    '  .student-info-actions { display: flex; gap: 12px; justify-content: flex-start; }',
    // 12px 24px (py-global-xs px-6) is the DS pill-button padding used
    // elsewhere (see _personal-coach.scss &__submit). The global .btn
    // (theme.scss:6027) sets line-height: 2 — at 16px text that alone is 32px,
    // plus this padding, for a ~56px-tall button. Reset it so total height
    // matches a normal DS pill button.
    '  .student-info-actions .btn { min-width: 120px; padding: 12px 24px; cursor: pointer; border-radius: 9999px; font-weight: 600; line-height: 1; }',
    '  .student-info-actions .btn-primary { background: #006feb; border: 1px solid #006feb; color: #fff; }',
    '  .student-info-actions .btn-secondary { background: transparent; border: 1px solid #d5dbe1; color: #080f17; }',
    '  .student-info-overlay .popup-slideup { max-width: 500px; padding: 40px !important; height: auto; border-radius: 10px; overflow-y: auto; max-height: 96%; }',
    '</style>',
    '<div class="student-info-popup">',
    '  <button type="button" class="student-info-close close" aria-label="Close">',
    '    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="none" aria-hidden="true"><path fill="currentColor" d="M205.66 194.34a8 8 0 0 1-11.32 11.32L128 139.31l-66.34 66.35a8 8 0 0 1-11.32-11.32L116.69 128 50.34 61.66a8 8 0 0 1 11.32-11.32L128 116.69l66.34-66.35a8 8 0 0 1 11.32 11.32L139.31 128Z"></path></svg>',
    '  </button>',
    '  <h2>Tell us about the student athlete using the 1:1 coaching session</h2>',
    '  <span class="student-info-eyebrow">Athlete info</span>',
    '  <div class="student-info-form">',
    '    <div class="student-info-field">',
    '      <label for="popup-student-name">Name <span class="required">*</span></label>',
    '      <input type="text" id="popup-student-name" placeholder="Student name">',
    '      <span class="field-error" id="error-student-name"></span>',
    '    </div>',
    '    <div class="student-info-field">',
    '      <label for="popup-student-email">Email <span class="required">*</span></label>',
    '      <input type="email" id="popup-student-email" placeholder="Student email">',
    '      <span class="field-error" id="error-student-email"></span>',
    '    </div>',
    '    <div class="student-info-field">',
    '      <label for="popup-student-phone">Phone Number <span class="optional">(optional)</span></label>',
    '      <input type="tel" id="popup-student-phone" placeholder="Phone number">',
    '    </div>',
    '    <p class="student-info-note">Once your purchase is complete, a member of our coaching team will reach out to the student athlete by email to setup the first session.</p>',
    '    <div class="student-info-actions">',
    '      <button type="button" class="btn btn-primary" id="popup-save-student">Save</button>',
    '      <button type="button" class="btn btn-secondary close" id="popup-cancel-student">Cancel</button>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join('\n');

  var overlay = new ContentOverlay2({
    btnOpen: null,
    containerClassOverride: 'fullscreen-overlay camp-popups student-info-overlay',
    overlayType: 'popup',
    type: 'html',
    content: popupHtml,
    callbackOpen: function() {
      setTimeout(function() {
        var nameField = document.getElementById('popup-student-name');
        if (nameField) nameField.focus();
      }, 300);

      // Save button handler
      $(document).off('click.studentInfoSave').on('click.studentInfoSave', '#popup-save-student', function() {
        var name  = $.trim($('#popup-student-name').val());
        var email = $.trim($('#popup-student-email').val());
        var phone = $.trim($('#popup-student-phone').val());

        // Reset errors
        $('.field-error').text('');
        $('.student-info-field').removeClass('has-error');

        var isValid = true;

        if (!name) {
          $('#error-student-name').text('Name is required.');
          $('#popup-student-name').closest('.student-info-field').addClass('has-error');
          isValid = false;
        }

        if (!email) {
          $('#error-student-email').text('Email is required.');
          $('#popup-student-email').closest('.student-info-field').addClass('has-error');
          isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          $('#error-student-email').text('Please enter a valid email address.');
          $('#popup-student-email').closest('.student-info-field').addClass('has-error');
          isValid = false;
        }

        if (!isValid) return;

        // Populate hidden fields in the product form
        $('#custom-student-name').val(name);
        $('#custom-student-email').val(email);
        $('#custom-student-phone').val(phone);

        // Close popup and continue add-to-cart
        overlay.close();
        window._imgaPlusPopupCompleted = true;
        onSaveCallback();
      });

      // Cancel button handler
      $(document).off('click.studentInfoCancel').on('click.studentInfoCancel', '#popup-cancel-student', function() {
        overlay.close();
      });

      // Close (X) button handler — the .close class alone doesn't work here:
      // ContentOverlay2's btnClose auto-wiring (this.template.container.find)
      // runs before our content HTML is inserted, so it never picks up an
      // element from `content`. Cancel already sidesteps this with its own
      // explicit handler above; do the same for the close button.
      $(document).off('click.studentInfoClose').on('click.studentInfoClose', '.student-info-close', function() {
        overlay.close();
      });
    },
    callbackClose: function() {
      // Clean up event handlers
      $(document).off('click.studentInfoSave');
      $(document).off('click.studentInfoCancel');
      $(document).off('click.studentInfoClose');
    }
  });

  overlay.open();
}
